import first from "./js/first";
import second from "./js/second";